import React, { useEffect, useState } from 'react';
import { __ } from '@wordpress/i18n';
import { Link, useNavigate } from 'react-router-dom';
import { head, isEmpty, pathOr } from 'ramda';
import NumberFlow from '@number-flow/react';

// store
import { useStoreValue } from '../../store';

// api
import DashboardService from '../../service/dashboard-service';

// components
import { Button } from 'primereact/button';
import ErrorBoundary from '../../components/ErrorBoundary';
import ListCompaniesTable from './components/ListCompaniesTable';

const DashboardBeneficiarioConfidi = () => {
    const navigate = useNavigate();
    const [mainStats, setMainStats] = useState({});
    const companies = useStoreValue('companies');
    const chosenCompanyId = useStoreValue('chosenCompanyId');
    const company = head(companies.filter(o => o.id === chosenCompanyId));


    const goToAddNewCompany = () => {
        navigate('/agguingi-azienda');
    }

    const getStatValue = (key, fallback = '') => {
        return pathOr(fallback, [key], mainStats);
    }

    const getStats = (resp) => {
        if (resp.status === 'SUCCESS') {
            setMainStats(() => ({
                ...resp.data
            }));
        }
    }

    const errGetStats = () => {
    }

    useEffect(() => {
        DashboardService.getBeneficiaryStatsForCompany(getStats, errGetStats);

        /*const userData = storeGet('userData');
        const roleType = pathOr('', ['role', 'roleType'], userData)

        console.log(roleType, companies)
        if (roleType === 'ROLE_CONFIDI' && (!companies || companies.length === 0)) {
            window.location.replace('/primo-accesso')
        }*/
    }, [companies, chosenCompanyId]);

    return (
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{__('Dashboard', 'htr')}</h1>
                {company ? <span className="companyName">{company.companyName}</span> : null}
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection statsBigBadges">
                <h2>{__('Panoramica di Sistema', 'htr')}</h2>
                <div className="statsBigBadges__grid grid-small">
                    {/*<div className="statsBigBadges__gridItem">
                        <span>{__('Aziende Attive', 'htr')}</span>
                        <span className="value"><NumberFlow
                            value={getStatValue('totalNumberOfActiveCompany', 0)}
                            format={{ notation: 'compact' }}
                            locales="it-IT"/></span>
                    </div>
                    <div className="statsBigBadges__gridItem">
                        <span>{__('Aziende in Sospeso', 'htr')}</span>
                        <span className="value"><NumberFlow
                            value={getStatValue('totalNumberOfCompanyOnHold', 0)}
                            format={{ notation: 'compact' }}
                            locales="it-IT"/></span>
                    </div>*/}
                    <div className="statsBigBadges__gridItem">
                        <span>{__('Documenti da Integrare', 'htr')}</span>
                        <span className="value"><NumberFlow
                            value={getStatValue('numberOfIntegratedDocuments', 0)}
                            format={{ notation: 'compact' }}
                            locales="it-IT"/></span>
                    </div>
                </div>
            </div>

            <div className="appPage__spacer"></div>

            {isEmpty(chosenCompanyId) || chosenCompanyId === 0
                ? <>
                    <div className="appPageSection__message warning">
                        <i className="pi pi-exclamation-triangle"></i>
                        <span className="summary">{__('Attenzione', 'htr')}</span>
                        <span>
                            {__('Per applicare ai form devi Registare un Azienda clicca', 'htr')}
                            <Link to={`/agguingi-azienda`} style={{ marginLeft: '0.5ch' }}>{__('qua', 'htr')}</Link>
                        </span>
                    </div>
                    <div className="appPage__spacer"></div>
                </> : null}

            <div className="appPageSection">
                <h2>{__('La mia Azienda', 'htr')}</h2>
                <ErrorBoundary><ListCompaniesTable/></ErrorBoundary>
            </div>

            <div className="appPage__spacer"></div>

            {/*<div className="appPageSection__hr">
                <span>{__('Azioni rapide', 'htr')}</span>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection">
                <div className="appPageSection__actions">
                    <Button
                        onClick={goToAddNewCompany}
                        label={__('Aggiungi azienda', 'htr')} icon="pi pi-plus" iconPos="right"/>
                </div>
            </div>*/}
        </div>
    )
}

export default DashboardBeneficiarioConfidi;